import { useState } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import SEO from '../components/SEO';

const FAQ = () => {
  const [open, setOpen] = useState(0);
  const faqs = [
    { q: 'How do I register for a tournament?', a: 'Browse tournaments on the Discover page, click any tournament card, and hit "Register". Fill in your details on Beyond Ball India — for paid tournaments, pay the organizer via UPI and upload your payment screenshot in the same form.' },
    { q: 'How do I list my tournament?', a: 'Create an organizer account, fill the tournament details form, and submit. Our team reviews every tournament within 24 hours to ensure quality.' },
    { q: 'Are there any fees?', a: 'Beyond Ball India is free to use for players and organizers. Individual tournaments may charge a registration fee set by their organizer — that fee and payment instructions are clearly displayed on each tournament page.' },
    { q: 'How does payment work for paid tournaments?', a: 'Organizers publish a UPI ID and QR code. You pay them directly, then upload your payment screenshot with your registration on Beyond Ball India. The organizer verifies and approves it.' },
    { q: 'How is my data used?', a: 'Your profile is private — only visible to you. We share your registration details with the tournament organizer when you register. See our privacy policy for details.' },
    { q: 'Can I cancel a registration?', a: 'Contact the tournament organizer directly. Cancellation policies vary per tournament.' }
  ];

  return (
    <>
      <SEO title="Frequently Asked Questions" description="Common questions about Beyond Ball India — how to register for tournaments, how to host one, fees, and more." path="/faq" />
      <div className="pt-24 pb-16 min-h-screen">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-xs font-semibold text-[#F97316] uppercase tracking-wider mb-2">Support</div>
          <h1 className="text-4xl sm:text-5xl font-bold tracking-tight text-gray-900 mb-10 animate-fade-up">Frequently asked questions</h1>
          <div className="space-y-3">
            {faqs.map((f, i) => (
              <div key={f.q} className="bg-white border border-gray-200 rounded-2xl overflow-hidden animate-fade-up" style={{animationDelay: `${i*50}ms`}}>
                <button onClick={() => setOpen(open === i ? -1 : i)} className="w-full px-6 py-5 flex items-center justify-between gap-4 text-left" data-testid={`faq-${i}`}>
                  <span className="font-semibold text-gray-900">{f.q}</span>
                  <CaretDown size={18} weight="bold" className={`text-gray-400 transition-transform flex-shrink-0 ${open === i ? 'rotate-180' : ''}`} />
                </button>
                {open === i && <div className="px-6 pb-5 text-gray-600 leading-relaxed">{f.a}</div>}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default FAQ;
